import React, { Component } from 'react';
import './style.scss';

export default class LoadingInBlock extends Component {
    render() {
        return (
            <div className="loadingInBlock">
                <div className="contentLoading">
                    <div className="loaderLine"></div>
                    <div className="label">Attendi</div>
                </div>
            </div>
        )
    }
}